exports.en = {
  BRANCHES_APPOINTMENTS: {
    BACK: 'Back',
    BRANCH_HEADER: {
      TITLE: 'Arrange an appointment at a branch on-line',
      DETAIL_BUTTON: 'Branch details'
    },
    SERVICE: {
      LABEL: 'Need special services for the disabled?',
      NO: 'No',
      YES: 'Yes',
      WHEELCHAIR_1: 'I’m disabled with wheelchair',
      WHEELCHAIR_2: 'and I need assistance at the entrance',
      INTERPRETATION_1: 'I need Online sign language interpretation',
      INTERPRETATION_2: '',
      BLIND_1: 'I’m blind',
      BLIND_2: 'and I need assistance at the entrance',
      TRANSCRIPT_1: 'I need Online text transcription',
      TRANSCRIPT_2: '',
      HINT: {
        LABEL: 'TIP',
        TEXT: 'See the detailed description of our branches for disabled at <a href="http://presbariery.cz/en/locations" target="_blank">www.presbariery.cz</a>'
      }
    },
    SELECT: {
      CALENDAR_DAY: {
        MORNING: 'Morning',
        NOON: 'Mid-morning',
        AFTERNOON: 'Afternoon',
        EVENING: 'Evening',
        OCCUPIED: 'Full',
        CLOSED: 'Closed'
      },
      NEXT_WEEK: 'Next week',
      PREV_WEEK: 'Previous week',
      TIME: {
        TITLE: 'Choose a time',
        SELECT: 'Select',
        OCCUPIED: 'Full',
        CLOSED: 'Closed'
      }
    },
    CREATE: {
      SELECTED_DATE: 'Chosen date',
      CHANGE_DATE: 'Change date',
      AT: 'at',
      NAME: {
        LABEL: 'Name',
        PLACEHOLDER: 'Name',
        REQUIRED: 'Required field'
      },
      SURNAME: {
        LABEL: 'Surname',
        PLACEHOLDER: 'Surname',
        REQUIRED: 'Required field'
      },
      PHONE: {
        LABEL: 'Telephone',
        PLACEHOLDER: 'XXX XXX XXX',
        TOOLTIP: 'For sending a notice before the meeting.',
        REQUIRED: 'Required field',
        PATTERN: 'Invalid format'
      },
      EMAIL: {
        LABEL: 'E-mail',
        PLACEHOLDER: 'E-mail',
        TOOLTIP: 'To send confirmation of appointment or cancellation.',
        REQUIRED: 'Required field',
        PATTERN: 'Invalid format'
      },
      TOPIC: {
        LABEL: 'Meeting topic',
        PLACEHOLDER: 'Meeting topic',
        REQUIRED: 'Required field',
        TOPICS: {
          MYLOANS: 'My instalments',
          MYPAYMENTS: 'My accounts',
          MYHOUSING: 'My housing',
          MYSAVINGS: 'My savings',
          MYINSURANCE: 'My insurance',
          MYFUTURE: 'My future',
          ENERGYGAS: 'Energy & Gas',
          MYBUSINESS: 'My business',
          FINANCIALADVICE: 'I need some financial advice'
        }
      },
      DESCRIPTION: {
        LABEL: 'Note',
        PLACEHOLDER: 'Note',
        TOO_LONG: 'Note is too long'
      },
      ERROR: {
        ORDER_IN_PAST: 'Can not be ordered for the past date',
        ORDER_RACE_CONDITION: 'The selected term is already occupied'
      },
      CREATE_BUTTON: 'Make an appointment at a branch',
      BACK_TO_SELECT_BUTTON: 'Back to term selection'
    },
    DETAIL: {
      SUCCESS_TITLE: 'Your appointment has been arranged successfully. What now?',
      PLANNED_AT: 'Selected date and time',
      AT: 'at',
      EMPLOYEE: 'Advisor',
      ORDER_CONFIRMATION_ON_EMAIL: 'Confirmation of your appointment has been sent to your e-mail <strong>%{email}</strong>. The message also contains a link to cancel the appointment.',
      CORRECT_MISTAKE: 'If you have selected the wrong time or place, you can cancel your appointment by following the link below:',
      CANCEL: 'Cancel appointment',
      CANCELLED_TITLE: 'You have successfully cancelled your appointment.',
      ORDER_CANCEL_ON_EMAIL: 'We have sent confirmation of cancellation of your appointment to your e-mail <strong>%{email}</strong>.',
      BRANCH_DETAIL: 'Back to the branch details'
    },
    CANCEL: {
      TITLE: 'Appointment cancellation',
      AT: 'at',
      DATE: 'Date',
      EMPLOYEE: 'Advisor',
      CLIENT_DATA: 'Client data',
      NAME: 'Name',
      PHONE: 'Telephone',
      EMAIL: 'E-mail',
      CANCEL_BUTTON: 'Cancel appointment',
      SUCCESS: 'Appointment cancellation was successful',
      BRANCH_DETAIL: 'Back to the branch details'
    },
    ERROR: {
      BRANCH_NOT_FOUND: 'Branch not found',
      APPOINTMENT_NOT_FOUND: 'Appointment not found',
      TIMESLOT_NOT_AVAILABLE: 'Timeslot not available'
    }
  }
}
